/* ==========================================================================
   ModTime — FAQ Search Command (vanilla, dependency-free)
   Recreates the kokonut "action search bar" interaction as an accessible
   command palette over the FAQ accordion: debounced live filtering, a
   suggestion dropdown, full keyboard control, and "jump to answer".
   Each .faq-search[data-faq-search] block self-initialises.
   ========================================================================== */
(function () {
  'use strict';

  var ICONS = {
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>',
    jump:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>',
    caret:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>',
    gear:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>',
    ruler:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M21.3 8.7 8.7 21.3a1 1 0 0 1-1.4 0l-4.6-4.6a1 1 0 0 1 0-1.4L15.3 2.7a1 1 0 0 1 1.4 0l4.6 4.6a1 1 0 0 1 0 1.4Z"/><path d="m7.5 10.5 2 2"/><path d="m10.5 7.5 2 2"/><path d="m13.5 4.5 2 2"/><path d="m4.5 13.5 2 2"/></svg>',
    truck:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h1"/><path d="M14 9h4l3 3v5a1 1 0 0 1-1 1h-1"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>',
    drop:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.7C9 6.3 5.5 9.9 5.5 14a6.5 6.5 0 0 0 13 0c0-4.1-3.5-7.7-6.5-11.3Z"/></svg>',
    spark:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v4"/><path d="M12 17v4"/><path d="M3 12h4"/><path d="M17 12h4"/><path d="m6.3 6.3 2.4 2.4"/><path d="m15.3 15.3 2.4 2.4"/><path d="m17.7 6.3-2.4 2.4"/><path d="m8.7 15.3-2.4 2.4"/></svg>',
    eye:    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z"/><circle cx="12" cy="12" r="3"/></svg>',
    help:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 2.5-3 4"/><path d="M12 17h.01"/></svg>'
  };

  var TAG_ICON = {
    movement: ICONS.gear, sizing: ICONS.ruler, shipping: ICONS.truck,
    water: ICONS.drop, custom: ICONS.spark, dial: ICONS.eye, basics: ICONS.help
  };

  /* MT-DE-BADGE-START: display only; internal tags stay unchanged. */
  function displayTag(tag) {
    if (document.documentElement.lang !== 'de') return tag;
    var labels = { basics: 'Grundlagen', movement: 'Uhrwerk', sizing: 'Größe',
      custom: 'Gestaltung', shipping: 'Versand', water: 'Wasser', dial: 'Zifferblatt' };
    var key = (tag || '').toLowerCase().trim();
    return Object.prototype.hasOwnProperty.call(labels, key) ? labels[key] : tag;
  }
  /* MT-DE-BADGE-END */

  function pickIcon(tag, text) {
    var byTag = TAG_ICON[(tag || '').toLowerCase().trim()];
    if (byTag) return byTag;
    var t = (text || '').toLowerCase();
    if (/(movement|nh3|vk6|caliber|mecha|quartz|automatic)/.test(t)) return ICONS.gear;
    if (/(size|sizing|adjust|bracelet|resize|link|fit|strap)/.test(t)) return ICONS.ruler;
    if (/(ship|shipping|deliver|dispatch|customs|carrier)/.test(t)) return ICONS.truck;
    if (/(water|resist|atm|splash|swim|dive)/.test(t)) return ICONS.drop;
    if (/(design|custom|own|logo|initial|personal|bespoke)/.test(t)) return ICONS.spark;
    if (/(clean|dial|marked|version|branding|minimal)/.test(t)) return ICONS.eye;
    return ICONS.help;
  }

  function norm(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeHtml(s) {
    return s.replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* highlight the matched substring inside a plain string -> safe HTML */
  function mark(label, q) {
    if (!q) return escapeHtml(label);
    var i = norm(label).indexOf(q);
    if (i < 0) return escapeHtml(label);
    return escapeHtml(label.slice(0, i)) +
      '<mark>' + escapeHtml(label.slice(i, i + q.length)) + '</mark>' +
      escapeHtml(label.slice(i + q.length));
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function ensureRuntimeStyles() {
    if (document.getElementById('modtime-faq-search-runtime-styles')) return;
    var style = document.createElement('style');
    style.id = 'modtime-faq-search-runtime-styles';
    style.textContent =
      '.faq-search__panel{display:block}' +
      '.faq-search__option{text-decoration:none}' +
      '.faq-search__hint{display:none}' +
      '@media screen and (max-width:749px){' +
        '.faq-search__option{align-items:flex-start}' +
        '.faq-search__opt-label{white-space:normal;overflow:visible;text-overflow:clip;line-height:1.35}' +
      '}';
    document.head.appendChild(style);
  }

  function init(root) {
    if (root.dataset.faqReady) return;
    root.dataset.faqReady = '1';
    ensureRuntimeStyles();

    var field   = root.querySelector('.faq-search__field');
    var input   = root.querySelector('.faq-search__input');
    var iconBox = root.querySelector('.faq-search__icon');
    var panel   = root.querySelector('.faq-search__panel');
    var list    = root.querySelector('.faq-search__list');
    if (!input || !panel || !list) return;

    if (iconBox) iconBox.innerHTML =
      '<span class="icon-search">' + ICONS.search + '</span>' +
      '<span class="icon-jump">' + ICONS.jump + '</span>';

    /* build the searchable index from the rendered accordion rows */
    var rows = Array.prototype.slice.call(root.querySelectorAll('.faq-search__row'));
    var faqBase = document.documentElement.lang === 'de' ? '/de/pages/faq' : '/pages/faq';
    var FAQ_ANCHORS = {
      'what is a custom modtime watch?': '#what-is-a-custom-modtime-watch',
      'which movements do we use?': '#movements',
      'can i adjust the watch size myself?': '#bracelet-sizing',
      'can i choose a clean or dial-marked version?': '#clean-or-marked',
      'can i design my own watch?': '#custom-design',
      'shipping time and costs': '#shipping',
      'shipping time, costs and tracking': '#shipping',
      'are the watches water resistant?': '#water-resistance',
      'warranty, support and returns': '#warranty-returns',
      'what about warranty, support and returns?': '#warranty-returns'
    };
    function faqUrlFor(label) {
      return faqBase + (FAQ_ANCHORS[norm(label)] || '');
    }
    var items = rows.map(function (row, i) {
      var details = row.querySelector('details');
      var qEl     = row.querySelector('.faq-search__q');
      var answer  = row.querySelector('.faq-search__answer');
      var label   = (qEl ? qEl.textContent : '').trim();
      var extra   = row.getAttribute('data-keywords') || '';
      var tag     = row.getAttribute('data-tag') || 'FAQ';
      var answerText = answer ? answer.textContent : '';
      if (!row.id) row.id = 'faq-row-' + i;
      qEl && qEl.setAttribute('data-label', label);
      return {
        row: row, details: details, qEl: qEl, index: i,
        label: label,
        tag: tag,
        nLabel: norm(label),
        nMeta: norm(extra + ' ' + tag),
        haystack: norm(label + ' ' + extra + ' ' + tag + ' ' + answerText),
        icon: pickIcon(tag, label + ' ' + extra),
        faqUrl: faqUrlFor(label)
      };
    });

    var highlight = -1;   /* index into the currently shown options */
    var shown = [];       /* item objects currently in the panel    */

    /* ARIA wiring (combobox + listbox) */
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'true');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', list.id || (list.id = root.id + '-listbox'));
    list.setAttribute('role', 'listbox');

    function openPanel()  { panel.classList.add('is-open'); input.setAttribute('aria-expanded', 'true'); }
    function closePanel() {
      input.setAttribute('aria-expanded', 'true');
      input.removeAttribute('aria-activedescendant');
      highlight = -1;
    }

    function renderOptions(matches, q) {
      shown = matches;
      if (!matches.length) {
        list.innerHTML =
          '<li class="faq-search__empty" role="option" aria-disabled="true">' +
          (document.documentElement.lang === 'de' ? 'Keine passende Frage — versuchen Sie „Uhrwerk“, „Größe“, „Versand“ oder „Wasser“.' : 'No matching question — try “movements”, “sizing”, “shipping” or “water”.') +
          '</li>';
        return;
      }
      var html = '';
      matches.forEach(function (it, idx) {
        var id = root.id + '-opt-' + idx;
        html +=
          '<li role="none">' +
            '<a role="option" id="' + id + '" class="faq-search__option" href="' + escapeHtml(it.faqUrl) + '" data-target="' + it.row.id + '" style="animation-delay:' + (idx * 0.035) + 's">' +
              '<span class="faq-search__opt-icon">' + it.icon + '</span>' +
              '<span class="faq-search__opt-body"><span class="faq-search__opt-label">' + mark(it.label, q) + '</span></span>' +
              '<span class="faq-search__opt-tag">' + escapeHtml(displayTag(it.tag)) + '</span>' +
            '</a>' +
          '</li>';
      });
      list.innerHTML = html;
    }

    function setHighlight(idx) {
      var opts = list.querySelectorAll('.faq-search__option');
      if (!opts.length) return;
      if (idx < 0) idx = opts.length - 1;
      if (idx >= opts.length) idx = 0;
      highlight = idx;
      opts.forEach(function (o, i) { o.classList.toggle('is-highlight', i === idx); });
      var active = opts[idx];
      input.setAttribute('aria-activedescendant', active.id);
      active.scrollIntoView({ block: 'nearest' });
    }

    /* live filter of the accordion + suggestion list */
    function update() {
      var raw = input.value;
      var q = norm(raw);
      field.classList.toggle('has-query', raw.length > 0);

      var matches;
      if (!q) {
        matches = items.slice();
      } else {
        /* rank: question hit (0) > tag/keyword hit (1) > answer-body hit (2) */
        matches = items.filter(function (it) { return it.haystack.indexOf(q) !== -1; });
        matches.forEach(function (it) {
          it._score = it.nLabel.indexOf(q) !== -1 ? 0
                    : it.nMeta.indexOf(q) !== -1 ? 1 : 2;
        });
        matches.sort(function (a, b) { return a._score - b._score || a.index - b.index; });
      }

      /* filter the visible accordion rows + highlight question text */
      items.forEach(function (it) {
        var hit = !q || matches.indexOf(it) !== -1;
        it.row.hidden = !hit;
        if (it.qEl) {
          var base = it.qEl.getAttribute('data-label') || it.label;
          it.qEl.innerHTML = hit ? mark(base, q) : escapeHtml(base);
        }
      });
      root.classList.toggle('is-empty', !!q && matches.length === 0);

      renderOptions(matches, q);
      openPanel();
      highlight = -1;
    }

    function goToFaq(rowId) {
      var it = items.filter(function (x) { return x.row.id === rowId; })[0];
      if (!it) return;
      window.location.assign(it.faqUrl);
    }

    function clearAll() {
      input.value = '';
      field.classList.remove('has-query');
      items.forEach(function (it) {
        it.row.hidden = false;
        if (it.qEl) it.qEl.innerHTML = escapeHtml(it.qEl.getAttribute('data-label') || it.label);
      });
      root.classList.remove('is-empty');
      update();
    }

    /* ---- events --------------------------------------------------------- */
    var debounced = debounce(update, 160);
    input.addEventListener('input', function () { field.classList.toggle('has-query', input.value.length > 0); debounced(); });
    input.addEventListener('focus', update);

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); openPanel(); setHighlight(highlight + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); openPanel(); setHighlight(highlight - 1); }
      else if (e.key === 'Enter') {
        var target = (highlight >= 0 && shown[highlight]) ? shown[highlight] : shown[0];
        if (target) { e.preventDefault(); goToFaq(target.row.id); }
      } else if (e.key === 'Escape') {
        if (input.value) { e.preventDefault(); clearAll(); }
        else closePanel();
      }
    });

    list.addEventListener('click', function (e) {
      var opt = e.target.closest('.faq-search__option');
      if (opt) { e.preventDefault(); goToFaq(opt.getAttribute('data-target')); }
    });

    update();
  }

  function boot() {
    document.querySelectorAll('.faq-search[data-faq-search]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  /* Shopify theme editor: re-init when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.faq-search[data-faq-search]');
    if (r) { delete r.dataset.faqReady; init(r); }
  });
})();
